import React from "react";
import { ListItemButton, ListItemText } from "@mui/material";
import { t } from "i18next";
import { PageRouteType, SectionRouteType } from "../../../front-office/constants/constants";
import { IMenuItem } from "./vp-menu";
import { VpMenuIconBadge } from "./vp-menu-icon-badge";

export interface IVpMenuItemProps {
    isRouteActive: boolean;
    badgeValue: number | undefined;
    item: IMenuItem<PageRouteType>;
    sectionRoute: SectionRouteType;
    changeTab: (sectionRoute: SectionRouteType, value: PageRouteType) => void;
}

export const VpMenuItem = (props: IVpMenuItemProps) => {
    return <ListItemButton
                     key={props.item.iconLabel}
                     onClick={() => props.changeTab(props.sectionRoute, props.item.route)}
                     className={`expansion-panel__second-level-container ${props.isRouteActive ? "expansion-panel__second-level-container--active" : ""}`}>
        <VpMenuIconBadge selected={props.isRouteActive ? "selected" : ""} badgeValue={props.badgeValue} icon={props.item.icon} iconStyle={props.item.iconStyle} />
        <ListItemText primary={t(props.item.iconLabel)}
                      slotProps={{
                          primary: {
                              className: "expansion-panel__second-level-label-text",
                          },
                          secondary: {
                              color: "inherit",
                          }}}
                      secondary={t(props.item.subLabel!)}
                      className={`expansion-panel__second-level-label  ${props.isRouteActive ? "expansion-panel__second-level-label--active" : ""}`} />
    </ListItemButton>;
};
